"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLicenseGroupUsers = exports.getLicenseGroups = exports.getLicenseGroup = void 0;

const utils_1 = require("../utils");

const getLicenseGroup = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/products/${options.productId}/license-groups/${options.licenseGroupId}`;
  return jilFetch(path, {}, {
    method: 'GET'
  });
};

exports.getLicenseGroup = getLicenseGroup;

const getLicenseGroups = (jilFetch, options) => {
  var _a;

  const path = `organizations/${options.orgId}/products/${options.productId}/license-groups/`;
  const params = utils_1.omitIfNil({
    page: (_a = options.page) !== null && _a !== void 0 ? _a : options.pageNumber,
    page_size: options.pageSize,
    search_query: options.searchQuery,
    sort: options.sort,
    sort_order: options.sortOrder
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getLicenseGroups = getLicenseGroups;

const getLicenseGroupUsers = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/products/${options.productId}/license-groups/${options.licenseGroupId}/users`;
  return jilFetch(path, {}, {
    method: 'GET'
  });
};

exports.getLicenseGroupUsers = getLicenseGroupUsers;